export function formatLandingCountryLabel(code: string): string {
	if (code === 'T1') {
		return 'Tor';
	}
	try {
		const name = new Intl.DisplayNames('ru', { type: 'region' }).of(code);
		return name ? `${code} · ${name}` : code;
	} catch {
		return code;
	}
}
